<script>
import { GlCollapsibleListbox, GlFormGroup } from '@gitlab/ui';
import produce from 'immer';
import getGroupProjects from 'ee/security_dashboard/graphql/queries/get_group_projects.query.graphql';
import { s__ } from '~/locale';

export default {
  components: {
    GlCollapsibleListbox,
    GlFormGroup,
  },
  inject: {
    fullPath: {
      required: true,
    },
  },
  apollo: {
    projects: {
      query: getGroupProjects,
      variables() {
        return {
          fullPath: this.fullPath,
        };
      },
      update(data) {
        return data.group?.projects?.nodes || [];
      },
      result({ data }) {
        this.pageInfo = data?.group?.projects?.pageInfo || {};
      },
    },
  },
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
    valid: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      projects: [],
      searchTerm: '',
      pageInfo: {},
    };
  },
  computed: {
    loading() {
      return this.$apollo.queries.projects.loading;
    },
    toggleText() {
      const selectedProject = this.projects.find((project) => project.id === this.value);
      return selectedProject?.name || s__('SecurityReports|Select project');
    },
    filteredProjects() {
      return this.projects.filter((project) =>
        project.name.toLowerCase().includes(this.searchTerm.toLowerCase()),
      );
    },
    items() {
      return this.filteredProjects.map((project) => ({ value: project.id, text: project.name }));
    },
  },
  methods: {
    setSearchTerm(term = '') {
      this.searchTerm = term.trim();
    },
    loadMore() {
      this.$apollo.queries.projects.fetchMore({
        variables: {
          fullPath: this.fullPath,
          after: this.pageInfo.endCursor,
        },
        updateQuery(previousResult, { fetchMoreResult }) {
          return produce(fetchMoreResult, (draftData) => {
            draftData.group.projects.nodes.unshift(...previousResult.group.projects.nodes);
          });
        },
      });
    },
  },
};
</script>

<template>
  <gl-form-group
    label-class="gl-hidden"
    :state="valid"
    :invalid-feedback="s__('SecurityReports|This selection is required.')"
    class="gl-mb-0"
    data-testid="project-form-group"
  >
    <gl-collapsible-listbox
      :value="value"
      searchable
      :items="items"
      :variant="valid ? 'default' : 'danger'"
      :category="valid ? 'primary' : 'secondary'"
      :infinite-scroll="pageInfo.hasNextPage"
      :infinite-scroll-loading="loading"
      :loading="loading"
      :toggle-text="toggleText"
      :aria-invalid="!valid"
      @bottom-reached="loadMore"
      @search="setSearchTerm"
      @select="$emit('input', $event)"
    />
  </gl-form-group>
</template>
